import * as Yup from 'yup';

export const documentSchema = Yup.object().shape({
  postcode: Yup.string()
    .max(9, 'Máximo 8 números')
    .min(9, 'Digite o CEP completo')
    .matches(/^[0-9-]*$/, 'Apenas números')
    .required('Campo obrigatório'),
});
